import React, {Suspense, useContext, useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import DetailChips from './Chips';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {useSelector} from 'react-redux';
const Collection = React.lazy(() => import('./Collection'));
const NewBusiness = React.lazy(() => import('./NewBusiness'));
const DebtorCash = React.lazy(() => import('./DebtorCash'));
const Statement = React.lazy(() => import('../Pages/Statement'));
const ViewClientNotes = React.lazy(() => import('../Pages/ViewClientNotes'));
const Billing = React.lazy(() => import('./Billing'));
const CorrespondingClient = React.lazy(() => import('../Pages/CorrespondingClient'));
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'marginBottom': '10px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
    // boxShadow:
    //   "0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '100%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function CustomTabs({selected, setSelected}) {
  const classes = useStyles();
  const [tab, setTab] = React.useState(0);
  const [newWindow, setNewWindow] = React.useState('');
  const [label, setLabel] = React.useState(['Internal Notepad']);
  const [roleDataClientMaintenance, setRoleDataClientMaintenance] = React.useState(['Internal Notepad']);
  const {currentLabel} = useContext(SelectTabContextProvider);
  const {roleData} = useSelector(({role}) => role);

  useEffect(() => {
    setRoleDataClientMaintenance(roleData?.window?.['Client Maintenance']);
  }, [roleData]);
  return (
    <div className={classes.root}>
      <DetailChips
        newWindow={newWindow}
        setNewWindow={setNewWindow}
        tab={tab}
        setTab={setTab}
        label={label}
        setLabel={setLabel}
        selected={selected}
        setSelected={setSelected}
      />
      <Suspense
        fallback={<div style={{textAlign: 'center', fontSize: '1.4rem'}}>Loading...</div>}
      >
        {label?.length > 0 &&
          label?.map((item, i) =>
            item === 'Corresponding Clients (W3)' ?
              roleData?.window?.['Client Maintenance']?.W3?.read && (
                <ErrorBoundaryForComponents key={i}>
                  <CorrespondingClient label={label} currentLabel={currentLabel} />
                </ErrorBoundaryForComponents>
              ) :
              item === 'Collection (W4)' ?
                roleData?.window?.['Client Maintenance']?.W4?.read && (
                  <ErrorBoundaryForComponents key={i}>
                    <Collection roleDataClientMaintenance={roleDataClientMaintenance} label={label} currentLabel={currentLabel} />
                  </ErrorBoundaryForComponents>
                ) :
                item === 'New Business (W5)' ?
                  roleData?.window?.['Client Maintenance']?.W5?.read && (
                    <ErrorBoundaryForComponents key={i}>
                      <NewBusiness roleDataClientMaintenance={roleDataClientMaintenance} label={label} currentLabel={currentLabel} />
                    </ErrorBoundaryForComponents>
                  ) :
                  item === 'Client Notes (W7)' ?
                    roleData?.window?.['Client Maintenance']?.W7?.read && (
                      <ErrorBoundaryForComponents key={i}>
                        <ViewClientNotes roleDataClientMaintenance={roleDataClientMaintenance} label={label} currentLabel={currentLabel} />
                      </ErrorBoundaryForComponents>
                    ) :
                    item === 'Billing (W16)' ?
                      roleData?.window?.['Client Maintenance']?.W16?.read && (
                        <ErrorBoundaryForComponents key={i}>
                          <Billing roleDataClientMaintenance={roleDataClientMaintenance} label={label} currentLabel={currentLabel} />
                        </ErrorBoundaryForComponents>
                      ) :
                      item === 'Debtor Cash (W18)' ?
                        roleData?.window?.['Client Maintenance']?.W18?.read && (
                          <ErrorBoundaryForComponents key={i}>
                            <DebtorCash roleDataClientMaintenance={roleDataClientMaintenance} label={label} currentLabel={currentLabel} />
                          </ErrorBoundaryForComponents>
                        ) :
                        item === 'Statement (W19)' ?
                          roleData?.window?.['Client Maintenance']?.W19?.read && (
                            <ErrorBoundaryForComponents key={i}>
                              <Statement roleDataClientMaintenance={roleDataClientMaintenance} label={label} currentLabel={currentLabel} />
                            </ErrorBoundaryForComponents>
                          ) :
                          null,
          )}
      </Suspense>
    </div>
  );
}
